import { isTrueValue } from "@utils/utilsValidators";

export const MFA_METHODS_GROUP_KEY = "mfa-methods";
// FE-only flag: it is never sent to the BE and just represents "no new-flow
// MFA method selected", i.e. the corporate keeps the legacy custom auth login.
export const LEGACY_CUSTOM_AUTH_KEY = "legacy_custom_auth";

export const isLegacyCustomAuth = (config?: {
  email_enabled?: any;
  totp_enabled?: any;
}) =>
  isTrueValue(config?.email_enabled) !== true &&
  isTrueValue(config?.totp_enabled) !== true;

// Legacy flag and new-flow methods are mutually exclusive, and exactly one of
// the two states is always selected.
const onChangeLegacy = (prevForm: any, checked: boolean) => {
  // The legacy flag is deselected only by choosing a new-flow method.
  if (!checked) return prevForm;
  return {
    ...prevForm,
    [LEGACY_CUSTOM_AUTH_KEY]: true,
    email_enabled: false,
    totp_enabled: false,
  };
};

const onChangeMethod =
  (accessorKey: string) => (prevForm: any, checked: boolean) => {
    const nextForm = { ...prevForm, [accessorKey]: checked };
    return {
      ...nextForm,
      [LEGACY_CUSTOM_AUTH_KEY]: isLegacyCustomAuth(nextForm),
    };
  };

export const withMfaMethodsBehavior = <T extends { accessorKey: string }>(
  column: T,
): T => {
  if (column.accessorKey !== MFA_METHODS_GROUP_KEY) return column;
  return {
    ...column,
    fields: (column as any).fields?.map((field: any) => ({
      ...field,
      onChangeForm:
        field.accessorKey === LEGACY_CUSTOM_AUTH_KEY
          ? onChangeLegacy
          : onChangeMethod(field.accessorKey),
    })),
  };
};
